import styled from 'styled-components'

export const Container = styled.div<{fixed?: boolean}>`
  font-family: "Whitney A", "Whitney B", -apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif;
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #000;
  color: #fff;
  background: var(--ggBackground);
  background-size:cover;
  background-position: center;
  font-size: 18px;

  ${props => props.fixed && `
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
  `}

  &, * {
    box-sizing: border-box;
  }
`

export const Div = styled.div`
  width: auto;
`
